import React from 'react'

import Routes from './routes'

import './App.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './css/magnific-popup.css'
import './css/nice-select.css'

function App(){
   
    return (
        <div>
            <Routes />
        </div>
       
    )
}

export default App
